import hrdc from "@/services/hrdc/config/menu.js";
import sso from "@/services/sso/config/menu.js";

export default {
  main: [
    {
      name: "My Workspace",
    },
    {
      type: "divider",
    },
  ],
  hrdc,
  // Event module menus are loaded dynamically from API via getEventConfig()
  sso,
};
